import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { withTranslation } from 'react-i18next';
import APNavMenuVertical from '../APNavMenuVertical/APNavMenuVertical';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import './SettingsMenuComponent.css';

const SettingsMenuClasses = getBEMClasses('settings-menu');

const SettingsMenuComponent = ({ systemMarginEnabled, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const node = useRef();

  const navItems = useMemo(() => {
    return [
      { text: 'Profile & Security', path: '/settings/user', icon: 'security' },
      // { text: 'IBA Settings', path: '/settings/iba', icon: 'sell' },
      systemMarginEnabled && { text: 'Trade Settings', path: '/settings/trade', icon: 'tasks' },
      { text: 'Verification Level', path: '/settings/verification-level', icon: 'tasks' },
      { text: 'Trade Reports', path: '/settings/trade-reports', icon: 'reports' },
      { text: 'API Keys', path: '/settings/api-keys', icon: 'key' },
      { text: 'User Contacts', path: '/settings/contacts', icon: 'contacts' },
      { text: 'Affiliate Program', path: '/settings/affiliate', icon: 'friends' },
      { text: 'Loyalty Token', path: '/settings/loyalty-token', icon: 'heart' },
      { text: 'Demo Settings', path: '/settings/demo-settings', icon: 'paint' },
    ].filter(Boolean);
  }, [systemMarginEnabled]);

  const toggle = useCallback(() => {
    setIsOpen((state) => !state);
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (node.current?.contains(e.target) === false) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleOutsideClick, false);
    return () => {
      document.removeEventListener('click', handleOutsideClick, false);
    };
  }, []);

  return (
    <div className={SettingsMenuClasses('container', isOpen ? '' : 'closed')} ref={node}>
      <div className={SettingsMenuClasses('menu-toggle', isOpen ? 'active' : '')} onClick={toggle}>
        {t('User Settings')}
        <div className={SettingsMenuClasses('triangles-container')}>
          <span className="triangle-up" />
          <span className="triangle-down" />
        </div>
      </div>
      <APNavMenuVertical customClass={SettingsMenuClasses()} handleNavItemClick={toggle} items={navItems} />
    </div>
  );
};

export default withTranslation()(SettingsMenuComponent);
